module.exports = __webpack_public_path__ + "static/media/rareChest__bottom.f2cf7340.png";